import { render } from "./slides_iframe_db_chap01.vue?vue&type=template&id=00d10ed4&scoped=true"
import script from "./slides_iframe_db_chap01.vue?vue&type=script&lang=js"
export * from "./slides_iframe_db_chap01.vue?vue&type=script&lang=js"

import "./slides_iframe_db_chap01.vue?vue&type=style&index=0&id=00d10ed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d10ed4"]])

export default __exports__